// Actions carry the ids the fixer ledger stores. Triggers are not repair targets, so
// they never appear as reportable actions.
const buildFixerActionOptions = (appDefinition) => (appDefinition?.actions || []).filter((action) => action?.id && action.type !== 'trigger').map((action) => ({ label: action.name || action.id, value: action.id }));

export default buildFixerActionOptions;
